import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";
import { CreateParameterFormValues } from "pages/Emails/EmailTemplateParameters/CreateParameterForm";
import { EditParameterFormValues } from "pages/Emails/EmailTemplateParameters/EditParameterForm";

const create = (data: CreateParameterFormValues): AxiosPromise => {
  return api.post(endpoints.EMAIL_PARAMETERS.CREATE(), data);
};
const update = (emailParameterId: number, data: EditParameterFormValues): AxiosPromise => {
  return api.put(endpoints.EMAIL_PARAMETERS.UPDATE(emailParameterId), data);
};

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string = "",
): AxiosPromise<BaseApiPaging<EmailParameterApi>> => {
  return api.get<BaseApiPaging<EmailParameterApi>>(endpoints.EMAIL_PARAMETERS.GET(skip, take, searchPhrase));
};

const fetchById = (id: number): AxiosPromise<EmailParameterApi> => {
  return api.get<EmailParameterApi>(endpoints.EMAIL_PARAMETERS.GET_BY_ID(id));
};
const deleteTemplate = (id: number): Promise<void> => {
  return api.delete(endpoints.EMAIL_PARAMETERS.DELETE(id));
};

export const emailparametersApi = {
  create,
  update,
  fetch,
  fetchById,
  delete: deleteTemplate,
};

export interface EmailParameterApi {
  id: number;
  name: string;
  value: string;
}
